import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";

const IssueTypeForm = ({
  token,
  onCloseModal,
  isEdit,
  rowData,
  refetchData,
}) => {
  const dispatch = useDispatch();

  const validationSchema = Yup.object({
    name: Yup.string()
      .required("Issue type name is required")
      .min(2, "Issue type name must be at least 2 characters")
      .max(100, "Issue type name must be less than 100 characters"),
  });

  const formik = useFormik({
    initialValues: {
      name: isEdit ? rowData?.name || "" : "",
    },
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        if (isEdit) {
          const payload = {
            uid: rowData?.uid,
            name: values.name,
          };

          const result = await dispatch(
            commonPostPutApi({
              method: "PUT",
              endpoint: "/ticketSystem/issue-type/update",
              token: token,
              payload: payload,
            })
          );

          if (result?.payload?.status) {
            toast.success(
              result?.payload?.message || "Issue type updated successfully!"
            );
            refetchData();
            onCloseModal();
          } else {
            toast.error(
              result?.payload?.message || "Failed to update issue type"
            );
          }
        } else {
          const payload = {
            name: values.name,
          };

          const result = await dispatch(
            commonPostPutApi({
              method: "POST",
              endpoint: "/ticketSystem/issue-type/add",
              token: token,
              payload: payload,
            })
          );

          if (result?.payload?.status) {
            toast.success(
              result?.payload?.message || "Issue type added successfully!"
            );
            refetchData();
            onCloseModal();
          } else {
            toast.error(result?.payload?.message || "Failed to add issue type");
          }
        }
      } catch (error) {
        toast.error("An error occurred. Please try again.");
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <div className="createNewCTOModalContainer mod-width-50p">
      <CommonHeadingNBtns
        title={`${isEdit ? "Edit" : "Add"} Issue Type`}
        onClick={formik.handleSubmit}
        isLoading={formik.isSubmitting}
        btnTxt={isEdit ? "Update" : "Add"}
        onClose={onCloseModal}
      />

      <form className="formContainer" onSubmit={formik.handleSubmit}>
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="name" className="formInputLabel">
              Issue Type Name <span className="required">*</span>
            </label>
            <div className="commonWrapper">
              <input
                type="text"
                id="name"
                name="name"
                className="formInput"
                placeholder="Enter issue type name"
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
            {formik.touched.name && formik.errors.name && (
              <div className="error-message">{formik.errors.name}</div>
            )}
          </div>
        </div>
      </form>
    </div>
  );
};

export default IssueTypeForm;
